import { isDefined } from "@clipboard-health/util-ts";
import { useWorkerGeoLocation } from "@src/appV2/Worker/useWorkerGeoLocation";
import { parseISO } from "date-fns";

import { useGetOpenShiftsForDates } from "../../Shift/Open/useGetOpenShiftsForDates";
import { getShiftDiscoveryDefaultDateRange } from "../../utils/getShiftDiscoveryDefaultDateRange";
import { usePayPreferenceFilterSettings } from "../featureFlags";
import { DEFAULT_DISTANCE_IN_MILES_FILTER } from "../Filters/constants";
import { useShiftDiscoveryUserFiltersContext } from "../Filters/useUserFiltersContext";

interface UseListViewOpenShiftsDataProps {
  distance?: number;
  pay: number;
}

export function useListViewOpenShiftsData(props: UseListViewOpenShiftsDataProps) {
  const { distance = DEFAULT_DISTANCE_IN_MILES_FILTER, pay } = props;
  const { dates: dateStrings } = useShiftDiscoveryUserFiltersContext();

  const workerGeoLocation = useWorkerGeoLocation();

  const { enabled: payPreferenceFilterEnabled } = usePayPreferenceFilterSettings();

  const dates = dateStrings.map((dateString) => parseISO(dateString));

  return useGetOpenShiftsForDates({
    dates,
    dateRange: getShiftDiscoveryDefaultDateRange(),
    filter: {
      area: {
        latitude: workerGeoLocation?.latitude ?? 0,
        longitude: workerGeoLocation?.longitude ?? 0,
        radiusInMiles: distance,
      },
    },
    enabled: isDefined(workerGeoLocation),
    includeOffers: payPreferenceFilterEnabled && pay > 0,
  });
}
